import React from 'react'
import { useTranslation } from 'react-i18next'
import './index.css'

import guestListImage from '../../../assets/weddingPlanner/588shots_so.png'
import floorPlanImage from '../../../assets/weddingPlanner/137shots_so.png'
import mobileImage from '../../../assets/weddingPlanner/666shots_so.png'
import assignmentImage from '../../../assets/weddingPlanner/817shots_so.png'

interface FeatureCardProps {
	image: string
	title: string
	description: string
}

const FeatureCard: React.FC<FeatureCardProps> = ({ image, title, description }) => (
	<div className='feature-card'>
		<div className='feature-card-image'>
			<img src={image} alt={title} />
		</div>
		<div className='feature-card-content'>
			<h3>{title}</h3>
			<p>{description}</p>
		</div>
	</div>
)

// Images for each feature (order must match translation items order)
const featureImages = [guestListImage, floorPlanImage, mobileImage, assignmentImage]

const WeddingPlanerFeatures: React.FC = () => {
	const { t } = useTranslation('planner')
	const featureItems = t('landing.features.items', { returnObjects: true }) as { title: string; description: string }[]

	return (
		<section className='planer-features-section'>
			<div className='planer-features-header'>
				<h2 className='planer-features-title'>
					{t('landing.features.title')}
				</h2>
				<p className='planer-features-subtitle'>
					{t('landing.features.subtitle')}
				</p>
			</div>

			<div className='planer-features-grid'>
				{featureItems.map((feature, index) => (
					<FeatureCard
						key={index}
						image={featureImages[index]}
						title={feature.title}
						description={feature.description}
					/>
				))}
			</div>
		</section>
	)
}

export default WeddingPlanerFeatures
